import { DatepickerRange, MultiselectItem, RangeDatepickerComponent } from '@ui/aos-lib';
import { DateUtil } from '@portal/shared/utils/date-util';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { FilterModel } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { FieldOperationsSensorsFieldName } from './field-operations-sensors.types';

const lastMonthRange = (): string[] => [
  DateUtil.toISOString((RangeDatepickerComponent.LAST_MONTH.getValue() as DatepickerRange).start),
  DateUtil.toISOString((RangeDatepickerComponent.LAST_MONTH.getValue() as DatepickerRange).end)
];

export const FIELD_OPERATIONS_SENSORS_DATE_TIME: FilterModel = {
  title: TranslateRegistry.get.FILTER.TITLE.DATE_TIME,
  items: [],
  selected: [],
  filterType: FieldOperationsSensorsFieldName.LastFieldOperationDateUtc,
  isDatepicker: true,
  minDate: null,
  width: 0,
  dateRange: lastMonthRange,
  defaultDateRange: lastMonthRange
};

const REASON_ITEMS: MultiselectItem[] = [
  { text: TranslateRegistry.get.FILTER.INSTALLATION_REASONS.ADD_EXGG, value: 'AddExgg' },
  { text: TranslateRegistry.get.FILTER.INSTALLATION_REASONS.ADD_SENSOR, value: 'AddSensor' },
  { text: TranslateRegistry.get.FILTER.INSTALLATION_REASONS.ADD_EXGG_ADD_SENSOR, value: 'AddExggAddSensor' },
  { text: TranslateRegistry.get.FILTER.INSTALLATION_REASONS.READ_EXGG, value: 'ReadExgg' },
  { text: TranslateRegistry.get.FILTER.INSTALLATION_REASONS.REPLACE_EXGG, value: 'ReplaceExgg' },
  { text: TranslateRegistry.get.FILTER.INSTALLATION_REASONS.REPLACE_SENSOR, value: 'ReplaceSensor' },
  {
    text: TranslateRegistry.get.FILTER.INSTALLATION_REASONS.REPLACE_EXGG_REPLACE_SENSOR,
    value: 'ReplaceExggReplaceSensor'
  },
  { text: TranslateRegistry.get.FILTER.INSTALLATION_REASONS.TURN_OFF_EXGG, value: 'TurnOffExgg' },
  { text: TranslateRegistry.get.FILTER.COMMON.UNKNOWN, value: 'Unknown' }
];

export const FIELD_OPERATIONS_SENSORS_REASON: FilterModel = {
  title: TranslateRegistry.get.FILTER.TITLE.REASON,
  items: REASON_ITEMS,
  selected: REASON_ITEMS,
  filterType: FieldOperationsSensorsFieldName.InstallationReason,
  isMultiselect: true,
  width: 184
};
